import CardImage from "../../assets/images/share_activity.svg";
import { useTranslation } from "react-i18next";

interface ShareActivityProps {
  onClick?: () => void;
}

function ShareActivity(props: ShareActivityProps) {
  const { t } = useTranslation();
  return (
    <div
      className="p-[20px_36px] bg-[linear-gradient(180deg,#f42cab_0%,#f1353a_100%)] rounded-2xl text-white font-dm-sans"
      onClick={props.onClick}
    >
      <p className="font-normal text-xs text-center tracking-[0.02em] leading-[130%] my-0 mx-5">
        {t("Bring friends and colleagues along the learning journey")}
      </p>
      <h5 className="font-bold text-base text-center tracking-[0.02em] leading-[120%] my-2">
        {t("Send invitation to new members")}
      </h5>
      <img src={CardImage} alt="" className="block mx-auto mt-[5px]" />
    </div>
  );
}

export default ShareActivity;
